import { BuyerUuid } from '@core/features/buyer-information/models/buyer-information-store.model';
import { HolderUuid } from '@products/models/holder.model';

export interface Person {
  id: PersonId;
  uuid: PersonUuid;
  type: PersonType;
}

export type PersonId = number;

export type PersonUuid = BuyerUuid | HolderUuid;

export type PersonUuids = PersonUuid[];

export enum PersonType {
  Buyer = 'buyer',
  Holder = 'holder',
  BuyerIsHolder = 'buyerIsHolder'
}
